import React from 'react';

// components
import { TextInput, DatePicker, EffectiveDate } from '../components/inputs';
import { FormRow } from '../components/layout';

function MedicareCoverage() {
  return (
    <div>
      <FormRow>
        <EffectiveDate />
      </FormRow>
      <FormRow>
        <TextInput
          label="Medicare Number"
          name="medicare_id"
          cols="6"
        />
      </FormRow>
      <FormRow>
        <DatePicker
          label="Hospital (Part A) Date"
          name="part_a_effective_date"
          cols="6"
        />
      </FormRow>
      <FormRow>
        <DatePicker
          label="Medical (Part B) Date"
          name="part_b_effective_date"
          cols="6"
        />
      </FormRow>
    </div>
  );
}

export default MedicareCoverage;
